module Client.Infrastructure.Table

open Fable.React
open Fable.React.Props

let rowIndexString index = index + 1 |> string |> str

let scrollableTable (table: ReactElement) : ReactElement =
    div [ Class "table-container" ] [ table ]